var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.Grid, {
        attrs: {
          alias: _setup.props.listName,
          commandButtons: _setup.commandButtons,
          itemData: _setup.courts,
          contextMenuItems: _setup.contextMenuItems,
          toolbarOptions: _setup.toolbarItemsOptions,
          toolbarClick: _setup.onToolbarClick,
          commandClick: _setup.onCommandClick,
          exportName: _setup.texts.exportName,
        },
        on: {
          rowClick: _setup.onRowClick,
          contextMenuClicked: _setup.onContextMenuClicked,
        },
      }),
      _c(_setup.PromptDialog, {
        attrs: {
          title: _setup.parseModalTitle,
          isOpened: _setup.openedPrompt,
          context: _vm.formAlias,
          formSchema: _setup.formSchema,
          formFieldValues: _setup.formData,
          width: _vm.modalWidth,
        },
        on: {
          "execute-action": _setup.onExecuteAction,
          changeFormField: _setup.onChangeFormField,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }